import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class UserService {

    static getUserProfile = () => {
        return axios.get(PATH.GET_PROFILE);
    }

    static getUserList = params => {
        return axios.get(PATH.GET_USER_LIST, {params});
    }

    static addUser = data => {
        return axios.post(PATH.ADD_USER, data);
    }

    static getUserById = id => {
        return axios.get(`${PATH.GET_USER_BY_ID}/${id}`);
    }

    static updateUserById = (data, id) => {
        return axios.put(`${PATH.UPDATE_USER_BY_ID}/${id}`, data);
    }

    static updateUserProfile = data => {
        return axios.put(PATH.UPDATE_USER_PROFILE, data);
    }

    static changeProfilePassword = data => {
        return axios.put(PATH.CHANGE_PASSWORD, data);
    }

    static changePasswordById = (data, id) => {
        return axios.put(`${PATH.CHANGE_PASSWORD}/${id}`, data);
    }

}
